export const featureGates = {
    ADULT_TEAM_PICKLEBALL: 'adult_team_pickleball',
    JUNIOR_TEAM_PICKLEBALL: 'junior_team_pickleball',
    GLOBAL_DROPDOWN_V2: 'global_dropdown_v2',
    WEB_LEAGUES_LARGE_TOURNAMENT_SIZES: 'web_leagues_large_tournament_sizes',
    LEAGUES_ORGANIZER_DIRECT_ADD: 'leagues_organizer_direct_add',
};

// The tier names Statsig scopes its rules to. A gate whose rules target "production" is never
// consulted unless the SDK is told the tier is exactly that string.
export const StatsigEnvironmentTiers = {
    PRODUCTION: 'production',
    STAGING: 'staging',
    DEVELOPMENT: 'development',
};

// Translates a CONFIG_SOURCE value (see src/config.js) into its Statsig environment tier.
// CONFIG_SOURCE is 'prod' in production and 'qa' in QA — never 'production' or 'staging' — so the
// values have to be mapped rather than compared directly. Comparing directly meant production
// reported the development tier, and every gate in this app was evaluated against its
// development rules while its production rules sat dead (ENG-2663).
// Unrecognized values fall back to development so a misconfigured build stays on the
// non-production side of every gate.
export const getStatsigEnvironmentTier = (configSource) => {
    switch (String(configSource ?? '').toLowerCase()) {
        case 'prod':
        case 'production': {
            return StatsigEnvironmentTiers.PRODUCTION;
        }
        case 'qa':
        case 'staging': {
            return StatsigEnvironmentTiers.STAGING;
        }
        default: {
            return StatsigEnvironmentTiers.DEVELOPMENT;
        }
    }
};
